import React, { useMemo, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAppError, useAppActions } from 'store/app';
import { useUser, ID } from 'store/user';
import { MAINTENANCE, checkMaintenanceDates } from 'utils/helper';

import { Container, Text, SupportLink } from './styles';

const AppError = () => {
  const timer = useRef();
  const { t } = useTranslation('app');
  const { pathname } = useLocation();
  const error = useAppError();
  const userId = useUser(ID);
  const { setAppError } = useAppActions();
  const maintenanceMessage = useMemo(
    () => (checkMaintenanceDates(true, pathname) ? t(...MAINTENANCE.warnMessage) : ''),
    [pathname, t]
  );

  useEffect(() => {
    if (error) {
      timer.current = setTimeout(() => {
        setAppError();
        timer.current = null;
      }, 7000);
    }
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [error, setAppError]);

  return (
    <Container $isOpen={Boolean(error) || Boolean(maintenanceMessage)}>
      {(error && (
        <Text>
          {error} {userId && <SupportLink to="/bugreport">{t('Report a problem')}</SupportLink>}
        </Text>
      )) ||
        (maintenanceMessage && <Text>{maintenanceMessage}</Text>)}
    </Container>
  );
};

export default AppError;
